import { ArrowsLeftRightIcon, BookOpenTextIcon, ChartLineIcon, HandshakeIcon, LifebuoyIcon, ProhibitIcon, ShoppingBagIcon, SlidersHorizontalIcon, SquaresFourIcon, TrayIcon, UsersIcon } from "@phosphor-icons/react";

// Shared by the desktop sidebar and the mobile dropdown. A section with `collapsible` renders as one
// expandable row (its `to` is where the row itself links); other sections render as a labelled group.
export const NAV_SECTIONS = [
  {
    label: "Operations",
    items: [
      { to: "/orders", label: "Orders", icon: SquaresFourIcon },
      { to: "/customers", label: "Customers", icon: UsersIcon },
      { to: "/ban-list", label: "Ban List", icon: ProhibitIcon },
    ],
  },
  {
    label: "Support",
    icon: LifebuoyIcon,
    to: "/support",
    collapsible: true,
    items: [
      { to: "/support", label: "Inbox", icon: TrayIcon },
      { to: "/support/knowledge", label: "Knowledge", icon: BookOpenTextIcon },
      { to: "/support/provider-tasks", label: "Provider Tasks", icon: HandshakeIcon },
      { to: "/support/settings", label: "AI Settings", icon: SlidersHorizontalIcon },
    ],
  },
  {
    label: "Catalog",
    items: [
      { to: "/products", label: "Products", icon: ShoppingBagIcon },
      { to: "/esim-product-mappings", label: "SKU Links", icon: ArrowsLeftRightIcon },
    ],
  },
  {
    label: "Insights",
    items: [{ to: "/statistics", label: "Analytics", icon: ChartLineIcon }],
  },
];

const ALL_ITEMS = NAV_SECTIONS.flatMap((section) => section.items);

const covers = (pathname, base) => pathname === base || pathname.startsWith(`${base}/`);

// "/support" is both the inbox and the prefix of its siblings, so the most specific matching item wins:
// /support/knowledge lights only Knowledge, /support/42 lights Inbox.
export const isItemActive = (pathname, to) => {
  if (!covers(pathname, to)) return false;
  return !ALL_ITEMS.some((item) => item.to.length > to.length && covers(pathname, item.to));
};

export const isSectionActive = (pathname, section) => section.items.some((item) => isItemActive(pathname, item.to));

export const userInitials = (user) => {
  const first = user?.firstName?.trim()?.[0] ?? "";
  const last = user?.lastName?.trim()?.[0] ?? "";
  const initials = `${first}${last}`.toUpperCase();
  return initials || (user?.email?.[0] ?? "?").toUpperCase();
};
